import clsx from 'clsx';
import { MotionProps, motion, HTMLMotionProps } from 'framer-motion';
import { useState } from 'react';
import { Icon } from '../Icon';
import { UseFloatingReturn, UseInteractionsReturn } from '@floating-ui/react';

export interface ListItemProps extends HTMLMotionProps<'div'> {
  index?: number;
  dataTestID?: string;
  withChevron?: boolean;
  children?: React.ReactNode;
  motionProps?: Omit<MotionProps, 'onHoverEnd' | 'onHoverStart'>;
  getFloatingReferenceProps?: UseInteractionsReturn['getReferenceProps']
  setFloatingReference?: UseFloatingReturn<HTMLDivElement>['refs']['setReference'];
}

export const ListItem = ({
  motionProps,
  index,
  className,
  children,
  withChevron,
  setFloatingReference,
  getFloatingReferenceProps,
  dataTestID,
  ...props
}: ListItemProps) => {
  const [hovered, setHovered] = useState(false);

  return (
    <motion.div
      data-testid={dataTestID}
      ref={setFloatingReference}
      {...getFloatingReferenceProps?.()}
      onHoverEnd={() => setHovered(false)}
      onHoverStart={() => setHovered(true)}
      onFocus={() => setHovered(true)}
      onBlur={() => setHovered(false)}
      className={clsx(
        'ListItem flex h-auto',
        props.onClick && 'cursor-pointer',
        index !== undefined
          ? index % 2 === 0
            ? 'bg-darkMode-gray-medium/10'
            : 'bg-darkMode-gray-medium/[0.03]'
          : 'odd:bg-darkMode-gray-medium/10 even:bg-darkMode-gray-medium/[0.03]',
        className
      )}
      {...motionProps}
      {...props}
    >
      <div className="ListItem-children-container contents">{children}</div>
      {withChevron && (
        <motion.div className="ListItem-chevron ml-2 self-center" animate={hovered ? { x: 4 } : { x: 0 }}>
          <Icon icon="chevronRight" className="text-palette-600" />
        </motion.div>
      )}
    </motion.div>
  );
};
